import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronMaximizeDiagonal2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M8.25,3H3.75c-.414,0-.75,.336-.75,.75v4.5c0,.414,.336,.75,.75,.75s.75-.336,.75-.75v-3.75h3.75c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75Z", fill: "currentColor" }),
        React.createElement("path", { d: "M14.25,9c-.414,0-.75,.336-.75,.75v3.75h-3.75c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75h4.5c.414,0,.75-.336,.75-.75v-4.5c0-.414-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconChevronMaximizeDiagonal2Fill18.js.map